import React, { useMemo, useState, useEffect } from "react";
import { GetNews } from "../../apis/api/NewsApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate ,useLocation} from "react-router-dom";
import Lodderr from "../../components/Lodder/Lodder";
import { formatDMY } from "../../utils/date";
import { motion } from "framer-motion";
import "./News.css";

const NewsPage = () => {
  const [newsData, setNewsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [q, setQ] = useState("");
  const newsPerPage = 8;
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const location = useLocation();


  const { news } = useSelector((state) => state.NewsSlice);
  const { loading } = useSelector((state) => state.NewsSlice);

  useEffect(() => {
    dispatch(GetNews());
  }, [dispatch]);
  useEffect(() => {
    if (news) {
      setNewsData(news);
    }
  }, [news]);

  const filtered = useMemo(() => {
    const term = q.trim().toLowerCase();
    if (!term) return newsData;
    return (newsData || []).filter((n) => {
      const title = (n?.title || "").toLowerCase();
      const desc = (n?.description || "")
        .replace(/<\/?[^>]+(>|$)/g, "")
        .toLowerCase();
      return title.includes(term) || desc.includes(term);
    });
  }, [newsData, q]);

  const totalPages = Math.max(1, Math.ceil((filtered?.length || 0) / newsPerPage));
  const indexOfLastNews = currentPage * newsPerPage;
  const indexOfFirstNews = indexOfLastNews - newsPerPage;
  const currentNews = filtered.slice(indexOfFirstNews, indexOfLastNews);

  useEffect(() => {
    setCurrentPage(1);
  }, [q]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const nextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const prevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));

  const handleRedirect = (news) => {
    navigate("/newsArticle", { state: { newsData: news ,from: location.pathname} });
  };
  return (
    <>
      {loading && <Lodderr />}
      <motion.div
        className="nw-wrap"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35, ease: [0.22, 0.68, 0, 1.2] }}
      >
        <div className="nw-hero">
          <div className="nw-hero__left">
            <h1 className="nw-title">News</h1>
            <p className="nw-sub">Latest updates from your network — clean, fast, premium.</p>
          </div>
          <div className="nw-hero__right">
            <div className="nw-search">
              <i className="bx bx-search"></i>
              <input
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Search news..."
              />
            </div>
            <div className="nw-count">
              <i className="bx bx-news"></i> {filtered.length} articles
            </div>
          </div>
        </div>

        {currentNews.length > 0 ? (
          <div className="nw-grid">
            {currentNews.map((n, idx) => {
              const img = n?.image ? n.image.replace("/thumb", "") : "assets/images/dummy-news-img.jpeg";
              const plain = (n?.description || "").replace(/<\/?[^>]+(>|$)/g, "");
              return (
                <motion.article
                  key={n.id || idx}
                  className="nw-card"
                  initial={{ opacity: 0, y: 18 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.03, duration: 0.35, ease: [0.22, 0.68, 0, 1.2] }}
                  whileHover={{ y: -6 }}
                  onClick={() => handleRedirect(n)}
                >
                  <div className="nw-thumb">
                    <img
                      src={img}
                      alt={n?.title}
                      loading="lazy"
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = "assets/images/dummy-news-img.jpeg";
                      }}
                    />
                    <span className="nw-badge">
                      <i className="bx bx-calendar"></i> {formatDMY(n?.created_at)}
                    </span>
                  </div>
                  <div className="nw-body">
                    <h3 className="nw-card-title">{n?.title || "Untitled"}</h3>
                    <p className="nw-card-desc">
                      {plain.length > 160 ? `${plain.slice(0, 160)}...` : plain}
                    </p>
                    <div className="nw-card-foot">
                      <button className="nw-btn" type="button" onClick={(e) => { e.stopPropagation(); handleRedirect(n); }}>
                        Read more <i className="bx bx-right-arrow-alt"></i>
                      </button>
                    </div>
                  </div>
                </motion.article>
              );
            })}
          </div>
        ) : (
          <div className="nw-empty">
            <i className="bx bx-news"></i>
            <p>No news found{q ? ` for “${q}”` : ""}.</p>
          </div>
        )}

        {totalPages > 1 && (
          <div className="nw-pagination">
            <button className="nw-page-btn" onClick={prevPage} disabled={currentPage === 1}>
              <i className="bx bx-chevron-left"></i> Prev
            </button>
            <div className="nw-pages">
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  onClick={() => paginate(i + 1)}
                  className={`nw-page-num ${currentPage === i + 1 ? "active" : ""}`}
                >
                  {i + 1}
                </button>
              ))}
            </div>
            <button className="nw-page-btn" onClick={nextPage} disabled={currentPage === totalPages}>
              Next <i className="bx bx-chevron-right"></i>
            </button>
          </div>
        )}
      </motion.div>
    </>
  );
};

export default NewsPage;
